__turbopack_context__.v({
  "condeNastPlayer": "condeNast-module-scss-module__izovGW__condeNastPlayer",
});
